import { createSlice, current, PayloadAction } from "@reduxjs/toolkit";
import {
  repairsData,
  repairsDataPost,
  repairsDataDelete,
  repairsDataID,
} from "./repairsActions";
import { ErrorResponse } from "src/types/error-response.type";
import { SuccessResponse } from "src/types/success-response.type";

import {RepairRequest, InsertRepair} from '../../types/request.type';

type RepairsState = {
  dataRepairs: {
    payload: RepairRequest[] | null;
    loading: boolean;
    success: boolean;
    error: string | null;
  };
};

const initialState: RepairsState = {
  dataRepairs: {
    payload: [],
    loading: false,
    success: false,
    error: "",
  },
};




const repairsSlice = createSlice({
  name: "repairs",
  initialState: initialState,
  reducers: {
    // Обычные редьюсеры
    setRepairsState(state, action: PayloadAction<RepairRequest[]>) {
      state.dataRepairs.payload = [];
      state.dataRepairs.payload = action.payload;
    },

    setRepairState(state, action: PayloadAction<RepairRequest[]>) {
      state.dataRepairs.payload = [];
      state.dataRepairs.payload = action.payload;
    },


  },

  extraReducers: (builder) => {
    builder
      .addCase(repairsData.pending, (state) => {
        state.dataRepairs.loading = true;
        state.dataRepairs.error = null;
      })
      .addCase(repairsData.fulfilled, (state, action) => {
        state.dataRepairs.loading = false;
        repairsSlice.caseReducers.setRepairsState(state, action);
      })
      .addCase(repairsData.rejected, (state, action) => {
        state.dataRepairs.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataRepairs.error = errorText ? errorText : "";
      })

      ////
      .addCase(repairsDataPost.pending, (state) => {
        state.dataRepairs.loading = true;
        state.dataRepairs.error = "";
      })
      .addCase(repairsDataPost.fulfilled, (state, action) => {
        state.dataRepairs.loading = false;
        //clientsSlice.caseReducers.setClientsState(state, action);
      })
      .addCase(repairsDataPost.rejected, (state, action) => {
        state.dataRepairs.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataRepairs.error = errorText ? errorText : "";
      })

  },
});


const getErrorText = (error: ErrorResponse) => {
  console.log(error);

  switch (error?.error) {
    case "invalid0":
      return "invalid0";
    case "invalid1":
      return "invalid1";
    default:
      return "";
  }
};

export default repairsSlice.reducer;
